<template>
  <div class="mainPage">
    <p id="headPage">VOUCER</p>
    <div class="cardRow">
      <!--   -->
      <div class="inRow">
        <div class="card" id="startBalance">
          <p id="titleCard">Saldo Awal</p>
          <p id="amountCard">{{formatUang(totalBalance.startBalance)}}</p>
        </div>
        <div class="card" id="inCard">
          <p id="titleCard">Kas Masuk</p>
          <p id="amountCard">{{formatUang(totalBalance.addDebt)}}</p>
        </div>
        <div class="card" id="outCard">
          <p id="titleCard">Kas Keluar</p>
          <p id="amountCard">{{formatUang(totalBalance.payDebt)}}</p>
        </div>
        <div class="card" id="balanceCard">
          <p id="titleCard">Saldo Akhir</p>
          <p id="amountCard">{{formatUang(totalBalance.endBalance)}}</p>
        </div>
      </div>
    </div>
    <div class="filterRow">
       
      <div class="inRow">
        <div class="inCol" id="cardFilter"  v-if="role == 'owner'">
          <p id="inputTitle">Cabang</p>
          <b-select v-model="findBranchId" @change="this.getVoucer">
            <option value="0" disabled>Pilih Cabang </option>
            <option v-for="e in this.branches" :key="e.id" :value="e.id"> {{e.branchName}} </option>
          </b-select>
        </div>
        <div class="inCol"  id="cardFilter">
          <p id="inputTitle">Jenis Voucer</p>
          <b-select v-model="findType" @change="this.getVoucer">
            <option :value=1> Pemasukan </option>
            <option :value=2> Pengeluaran </option>
          </b-select>
        </div>
        <div class="inCol"  id="cardFilter">
          <p id="inputTitle">Status Voucer</p>
          <b-select v-model="findStatus"  @change="this.getVoucer">
            <option :value=1> Urgent </option>
            <option :value=2> Planing </option>
          </b-select>
        </div>
      </div>
      <div class="inRow">
        <div class="inCol" id="cardFilter">
          
          <p id="inputTitle" >Tanggal Mulai</p>
          <b-input type="date"  v-model="startDate"  @change="this.getVoucer"></b-input>
        </div>
        <div class="inCol" id="cardFilter">
          <p id="inputTitle">Tanggal Selesai</p>
          <b-input type="date" v-model="endDate"  @change="this.getVoucer"></b-input>
        </div>
        <div class="inCol" id="cardFilter">
          <p id="inputTitle">Keyword</p>
          <b-input type="text" v-model="keyword"  @change="this.getVoucer"></b-input>
        </div>
      </div>
    </div>
    <div id="titleRow">
      <b-button id="addModal" @click.prevent="showAdd()" v-if="role == 'cashier'">Tambah</b-button>
      <b-button id="resetFilter" @click.prevent="resetFilter()">Reset Filter</b-button>
      <b-button id="transferButton" @click.prevent="showTransfer()" v-if="role == 'cashier'">Transfer Dana</b-button>
      <button @click.prevent="printCsv()" id="printer">
        <img src="../assets/printer.png" id="printer" alt="">
      </button>
    </div>
    <div class="pagination mt-2">
        <button type="button" class="mr-1" id="pageButton" v-if="currentPage > 1"  @click.prevent="minPage()"> &lt; </button>
        <button class="mr-1" id="pageButton" v-if="currentPage <= 1"  > &lt; </button>
        <p class="mr-1"> {{this.currentPage}} </p>
        <p class="mr-1">/</p> 
        <p class="mr-1">{{this.totalPage}} </p> 
        <button type="button" id="pageButton" v-if="this.currentPage < this.totalPage" @click.prevent="addPage()"> > </button>
        <button id="pageButton" v-if="this.currentPage >= this.totalPage" > > </button>
      </div>
    <div class="tableRow">
      <div class="inRow">
        <lord-icon
          v-if="this.isLoading"
          src="https://cdn.lordicon.com/dpinvufc.json"
          trigger="loop"
          style="width:300px;height:300px">
        </lord-icon>
      </div>
      
      <table v-if="!isLoading" class="table-bordered table-hover" id="tableData">
        <thead>
          <tr>
            <th>#</th>
            <th>Tanggal</th>
            <th>No.Reff</th>
            <th>Cabang</th>
            <th>Jenis</th>
            <th>Keterangan</th>
            <th>Jumlah</th>
            <th colspan="4">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(e,index) in this.voucers" :key="e.id">
            <td>{{ index+1 }}</td>
            <td>{{formatDate(e.date)}} </td>
            <td> {{e.refNo}} </td>
            <td> {{e.Branch.branchName}} </td>
            <td v-if="e.type == 1" class="text-center"> <img id="status" src="../assets/masuk.png" alt=""> </td>
            <td v-if="e.type == 2" class="text-center"> <img id="status" src="../assets/keluar.png" alt=""> </td>
            <td> {{e.notes}}  <img v-if="e.isEdit" id="edited" src="../assets/edited.png" alt=""> </td>
            <td class="uang"> {{ formatUang(e.amount)}} </td>
            <td id="action" class="text-center" v-if="role == 'cashier'">
                <button @click.prevent="setPrintData(e)" title="Print" >
                  <img src="../assets/print2.png" alt="">
                </button>
              </td>
              <td id="action" class="text-center" >
                <button @click.prevent="changeStatus(e)" title="Print" >
                  <img v-if="e.isOpen" src="../assets/gembokGreen.png" alt="">
                  <img v-if="!e.isOpen" src="../assets/gembokRed.png" alt="">
                </button>
              </td>
              <!-- <td v-if="e.isEdit == 1" class="text-center"> <img id="edited" src="../assets/edited.png" alt=""> </td> -->
              <!-- <td id="action" class="text-center" >
                <button @click.prevent="changeStatus(e.id)" title="Ubah Status Open" >
                  <lord-icon
                    src="https://cdn.lordicon.com/wloilxuq.json"
                    trigger="hover">
                  </lord-icon>
                </button>
            </td> -->
            <td id="action" class="text-center"  v-if="role == 'cashier' && e.isOpen" >
              <button @click.prevent="showEdit(e)" title="Edit" >
                <img src="../assets/edit.png" alt="">
              </button>
            </td>
            <td id="action" class="text-center"  v-if="role == 'cashier'">
              <button @click.prevent="confirmDelete(e.id)" title="Hapus">
                <img src="../assets/trash.png" alt="">
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination mt-2">
        <button type="button" class="mr-1" id="pageButton" v-if="currentPage > 1"  @click.prevent="minPage()"> &lt; </button>
        <button class="mr-1" id="pageButton" v-if="currentPage <= 1"  > &lt; </button>
        <p class="mr-1"> {{this.currentPage}} </p>
        <p class="mr-1">/</p>
        <p class="mr-1">{{this.totalPage}} </p> 
        <button type="button" id="pageButton" v-if="this.currentPage < this.totalPage" @click.prevent="addPage()"> > </button>
        <button id="pageButton" v-if="this.currentPage >= this.totalPage" > > </button>
      </div>
    </div>

    <!-- Transfermodal -->
  <div class="modal" id="transferModal" tabindex="-1">
  <!-- <div class="modal-dialog"> -->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Transfer Antar Perusahaan</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" >&times; </span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="transferVoucer()">
          <div class="inRow">
            <div class="inCol" >
              <p id="titleModal">Tujuan Transfer</p>
              <b-select v-model="transfer.BranchToId" required>
                <option :value="e.id" v-for="e in this.listBranch" :key="e.id">{{ e.branchName }}</option>
              </b-select>
            </div>
            <div class="inCol">
              <p id="titleModal">Tanggal</p>
              <b-input v-model="transfer.date" type="date" required></b-input>
            </div>

            <div class="inCol">
              <p id="titleModal">Jumlah</p>
              <b-input class="text-right" v-model="transfer.amount" type="text" @input="currencyNumber($event)"  required></b-input>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">Tambah</button>
          </div>
        </form>
      </div>
    </div>
  <!-- </div> -->
</div>
      <!-- Main Modal -->
  <div class="modal" id="mainModal" tabindex="-1">
  <!-- <div class="modal-dialog"> -->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Voucer</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" >&times; </span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="isEdit ? editVoucer() : addVoucer()">
          <div class="inRow">
            <div class="inCol" v-if="role == 'owner'">
              <p id="titleModal">Nama Cabang</p>
              <b-select v-model="BranchId" required>
                <option :value="e.id" v-for="e in this.branches" :key="e.id">{{ e.branchName }}</option>
              </b-select>
            </div>
            <div class="inCol">
              <p id="titleModal">Tanggal</p>
              <b-input v-model="date" type="date" required></b-input>
            </div>
            <div class="inCol">
              <p id="titleModal">Jenis Voucer</p>
              <b-select v-model="type" required>
                <option value="1">Pemasukan</option>
                <option value="2">Pengeluaran</option>
              </b-select>
            </div>
            <!-- <div class="inCol" v-if="this.type == 2">
              <p id="titleModal">Status Voucer</p>
              <b-select v-model="status">
                <option value="1">Urgent</option>
                <option value="2">By Planing</option>
              </b-select>
            </div> -->
            <div class="inCol">
              <p id="titleModal">Jumlah</p>
              <b-input class="text-right" v-model="amount" type="text" @input="currencyNumber($event)"  required></b-input>
            </div>
          </div>
          <div class="inRow">
          </div>
          <div class="inRow">
            <div class="inCol">
              <p id="titleModal">Keterangan</p>
              <b-input v-model="notes" name="detail" type="text" required></b-input>
            </div>
          </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-primary">Tambah</button>
        </div>
      </form>
      </div>
    </div>
  <!-- </div> -->
  </div>
<!-- Print -->
  <div id="printArea">

    <div class="headPrint">
      <p id="titlePrint" v-if="this.print.type == 1">Voucer Penerimaan</p>
      <p id="titlePrint" v-if="this.print.type == 2">Voucer Pengeluaran</p>
      <p id="brancName"> {{ print.branchName }} </p>
      <p id="datePrint"> {{ print.date }} </p>
    </div>
    <hr>
    <div class="mainPrint">
      <table class="table table-borderless" id="printTable">
          <tr>
            <td id="keyTable">Nomor</td>
            <td id="titikDua">:</td>
            <td>{{ print.nomor }}</td>
          </tr>
          <tr>
            <td id="keyTable">Jumlah</td>
            <td id="titikDua">:</td>
            <td>Rp.{{ print.amount }}</td>
          </tr>
          <tr>
            <td id="keyTable">Keterangan</td>
            <td id="titikDua">:</td>
            <td>{{ print.notes }}</td>
          </tr>
      </table>
      <hr>
    </div>
    <div class="signArea">
      <div class="inRow">
        <div class="inCol">
          <p id="name">Kasir</p>
          <p>(............................)</p>
        </div>
        <div class="inCol" v-if="this.print.type == 1">
          <p id="name">Pemberi</p>
          <p>(............................)</p>
        </div>
        <div class="inCol" v-if="this.print.type == 2">
          <p id="name">Penerima</p>
          <p>(............................)</p>
        </div>
        <div class="inCol">
          <p id="name">Akuntansi</p>
          <p>(............................)</p>
        </div>
        <div class="inCol">
          <p id="name">Direktur</p>
          <p>(............................)</p>
        </div>
      </div>
    </div>
    <hr>
  </div>
</div>
</template>

<script>
import axios  from '../API/axios'
import Swal from "sweetalert2";
import moment from 'moment'
import csvDownload from 'json-to-csv-export'
import html2pdf from "html2pdf.js";
export default {
  name: "Voucer",
  data() {
    return  {
      id: 0,
      voucers: [],
      currentPage: 1,
      perPage: 40,
			totalPage : 1,
      isLoading: false,
      isEdit: false,
      totalBalance: {},
      
      // filter
      findBranchId: 0,
      findType: "",
      findStatus: "",
      startDate: "",
      endDate: "",
      keyword: "",
      listBranch: [],

      // modal
      BranchId: 0,
      amount: '',
      notes: "",
      status: 1,
      date: "",
      type: "",

      transfer: {
        amount: 0,
        BranchToId: 0,
        date: moment(new Date).format('YYYY-MM-DD')
      },

      // print
      print: {
        branchName: '',
        date: '',
        nomor: '',
        notes: '',
        amount: '',
        type: 0
      }

    }
  },
  created() {
    this.$store.dispatch("getBranch")
    this.getVoucer()
    this.getBranch()
  },
  computed: {
    branches() {
      return this.$store.state.branches
    },
    role() {
      return localStorage.getItem("role");
    },
  },  
  methods: {
    resetFilter() {
      this.findBranchId= 0
      this.currentPage = 1
      this.findType= ""
      this.findStatus= ""
      this.startDate= ""
      this.endDate= ""
      this.getVoucer()
    },
    showAdd() {
      this.isEdit = false
      this.date = moment(new Date).format("YYYY-MM-DD")
      $('#mainModal').modal('show')
    },
    showTransfer() {
      this.transfer.date = moment(new Date).format("YYYY-MM-DD")
      $('#transferModal').modal('show')
    },

    setPrintData(e) {
      this.print.branchName = e.Branch.branchName,
      this.print.date = moment(e.date).format('DD-MM-YYYY')
      this.print.nomor = e.refNo
      this.print.amount = this.formatUang(e.amount)
      this.print.notes = e.notes
      this.print.type = e.type
      this.exportToPDF()
    },

    exportToPDF() {
      this.isLoading = true
      document.getElementById('printArea').style.display='block'
      html2pdf(document.getElementById('printArea'),  {
        margin: 1,
        filename: "Voucer.pdf",
      }).then(e => {
        document.getElementById('printArea').style.display='none'
        this.isLoading = false
      })
    },

    showEdit(e) {
      this.id = e.id
      this.isEdit = true
      $('#mainModal').modal('show')
      this.BranchId=  e.BranchId,
      // OrderId=  e.OrderId,
      this.date=  e.date,
      this.status=  e.status,
      this.type=  e.type,
      this.notes=  e.notes,
      this.amount=  this.setEditAmount(e.amount)
    },

    currencyNumber(event, target) {
        console.log(event, "===================");
        let currentValue = event.trim().split('.').filter(e => e != '.' ).join('')

        console.log(currentValue, typeof currentValue," -----------");
        if( Number.isNaN(Number(currentValue))) {

          this.amount = this.formatUang(currentValue.split('').filter(e => !Number.isNaN( Number(e))).join(''))
          return
        }
        // currentValue = this.amount
        this.amount = this.formatUang(currentValue)
        this.transfer.amount = this.formatUang(currentValue)
    },
    setEditAmount(currentValue) {
      let result = 0
      if( Number.isNaN(Number(currentValue))) {
          // this.amount = 10
          this.amount = this.formatUang(currentValue.split('').filter(e => !Number.isNaN( Number(e))).join(''))
          return
        }
        // currentValue = this.amount
      result = this.formatUang(currentValue)
      return result 
    },


    async changeStatus(e) {
      
      try {
        if(e.status == 2 && e.amount > 2000000) return  Swal.fire('Maaf', 'data anda tidak dapat diubah', 'error');
        let data2 = await axios({
          method: "patch",
          url: `/voucer/isopen/${e.id}`,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        Swal.fire('Berhasil', 'Data berhasil diproses', 'success');
        this.getVoucer()
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    },
    formatDate(date) {
      let result = ''
      if(date) return moment(date).format("DD-MM-YYYY")
    },
    cekStatus(data) {
      let result = ""
      if(data == 2) {
        result = 'By Planing'
      } else if(data == 1) {
        result= 'Urgent'
      }
      return result
    },
    formatUang(data) {
      // console.log(data);
        
      let uang = "";
        if(data) {
          data = data.toString();
          for (let i = 0; i < data.length; i++) {
            if ((data.length - i) % 3 == 0 && i !== 0) {
            uang += `.${data[i]}`;
            } else {
            uang += data[i];
            }
          }
        }
        return uang
    },
    async getBranch() {

      try {

        let {data} = await axios({
          method: 'get',
          url: '/user/branch2',
          headers: {
            access_token: localStorage.getItem("access_token")
          }
        })
        this.listBranch = data

      } catch(err) {
        console.log(err);
      }
    },
    async getVoucer() {
      this.isLoading = true
      try {
        
        let {data} = await axios({
          method: "GET",
          url: "/voucer",
          headers: {
            access_token: localStorage.getItem("access_token")
          },
          params: {
            startDate: this.startDate,
            endDate: this.endDate,
            page: this.currentPage,
            limit: this.perPage,
            BranchId: this.findBranchId,
            type: this.findType, 
            status: this.findStatus, 
            keyword : this.keyword
          }
        })
        console.log(data);
        this.voucers = data.data2.result
        let totalPage = Math.ceil(data.data2.dataLength / this.perPage)
				this.totalPage = totalPage
        this.isLoading = false
        this.totalBalance = data.totalBalance
      } catch(err) {
        this.isLoading = false
        console.log(err);
      }

    },
    async printCsv() {
      this.isLoading = true
      try {
        
        let {data} = await axios({
          method: "GET",
          url: "/voucer/print",
          headers: {
            access_token: localStorage.getItem("access_token")
          },
          params: {
            startDate: this.startDate,
            keyword: this.keyword,
            BranchId: this.findBranchId,
            type: this.findType, 
            status: this.findStatus, 
          }
        })
        const dataToConvert = {
          data: data,
          filename: 'Voucer',
          delimiter: ',',
        }
        csvDownload(dataToConvert)
        this.isLoading= false
      } catch(err) {
        this.isLoading = false
        console.log(err);
      }
      
    },
    
    async addVoucer() {
      
      try {
        $('#mainModal').modal('hide')
        let status = null
        if(this.type == 2) {
          status = this.status
        }

        let amount = this.amount.trim().split('.').filter(e => e != '.' ).join('')
        let data =  {
          BranchId:  this.BranchId,
          date:  this.date,
          status:  this.status,
          type:  this.type,
          notes:  this.notes,
          amount:  amount,
        }

        let data2 = await axios({
          method: "POST",
          url: "/voucer",
          data: data,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        this.BranchId=  0
        this.date=  ""
        this.status=  1
        this.type=  ""
        this.notes=  ""
        this.OrderId=  ""
        this.amount=  0
        Swal.fire('Berhasil', 'Data Berhasil Ditambahkan', 'success');
        this.getVoucer()
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    },
    async transferVoucer() {

      try {
        let status = null
        if(this.type == 2) {
          status = this.status
        }

        let amount = this.transfer.amount.trim().split('.').filter(e => e != '.' ).join('')
        let data =  {
          date:  this.date,
          BranchToId : this.transfer.BranchToId,
          amount:  amount,
        }

        let data2 = await axios({
          method: "POST",
          url: "/voucer/transfer",
          data: data,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        $('#transferModal').modal('hide')
        this.amount=  0
        Swal.fire('Berhasil', 'Data Berhasil Ditambahkan', 'success');
        this.getVoucer()
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    },

    async editVoucer() {

      try {
        
        let payload =  {
          BranchId:  this.BranchId,
          date:  this.date,
          status:  this.status,
          type:  this.type,
          notes:  this.notes,
          amount:  this.amount.trim().split('.').filter(e => e != '.' ).join(''),
          isOpen : false
        }

        let data2 = await axios({
          method: "put",
          url: `/voucer/${this.id}`,
          data: payload,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        $('#mainModal').modal('hide')
        this.getVoucer()
        this.BranchId=  0
        this.date=  ""
        this.status=  ""
        this.type=  ""
        this.notes=  ""
        this.OrderId=  ""
        this.amount=  0
        this.id=  0
        Swal.fire('Berhasil', 'Data Berhasil Ditambahkan', 'success');
        
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    }, 

    async deleteData(id) {
      
      try {
        
        let data = await axios.delete(`/voucer/${id}`, {
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        Swal.fire('Berhasil', 'Data Berhasil Dihapuskan', 'success');
        this.getVoucer()

      } catch(err) {
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');

      } 
    },
    async confirmDelete(id) {
      
      try {
        let data = await Swal.fire({
            title: 'Yakin?',
            text: 'Apakah Yakin ',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Hapus!!',
        })
        if (data.isConfirmed) {
            this.deleteData(id);
            this.getVoucer()
        } else {
                Swal.fire('Ok', 'Proses anda berhasil dibatalkan', 'error');
              }
              
              
            } catch(err) {
              
              Swal.fire('Maaf', 'Proses anda berhasil dibatalkan', 'error');
      }
    },
    addPage() {
      this.currentPage = this.currentPage + 1
      this.getVoucer()
    },
    minPage() {
      this.currentPage = this.currentPage - 1
      this.getVoucer()
    },
  }
}
</script>

<style scoped>
  .cardRow {
    /* display: flex; */
    width: 100%;
    /* background-color: aqua; */
  }
  #transferButton {
    margin-left: 10px;
    background-color: #17a2b8;
    border: none;
  }





</style>